<template>
  <div v-if="!editState" @dblclick="openValue">
    {{value[fieldInfo.fieldAliasName]}}
  </div>
  <div v-else>
    <el-input-number v-model="value[fieldInfo.fieldAliasName]" size="mini" @change="changeValue" :min="1" label=""></el-input-number>
    <el-button type="success" size="mini" icon="el-icon-check" circle @click="comfirmValue"></el-button>
    <el-button type="danger" size="mini" icon="el-icon-close" circle @click="cancelValue"></el-button>
  </div>
</template>

<script>

import pageUtils from '@/js/page/pageUtil.js';
import utils from '@/js/utils/util.js';
export default {
  name: 'kw_px_edit',
  props: {
    fieldInfo: {
      type:Object,
      default:function(){
        return {};
      }
    },
    fieldIndex:{
      type:Number
    },
    value:{
      type:Object,
      default:function(){
        return {};
      }
    },
    dataIndex:{
      type:Number
    },
    pageSetInfo:{
      type:Object,
      default:function(){
        return {};
      }
    }
  },
  data() {
    return {
      //编辑状态
      editState:false,
      editPrevValue:0,
    };
  },
  created() {
    
  },
  mounted() {
    
  },
  watch:{
  },
  computed:{
  },
  components: {
   
  },
  methods: {
    styleSetCodeZdy(json,rowData) {
      if(json) {
        var styleSetCode = json.styleSetCode;
        if(json.zdyJs) {
          styleSetCode += eval(json.zdyJs);
        }
        return styleSetCode;
      } else {
        return "";
      }
    },
    openValue() {
      this.editState = true;
      this.editPrevValue = this.value[this.fieldInfo.fieldAliasName];
    },
    changeValue(value){
    },
    comfirmValue(){
      var that = this;
      //进行后台的排序保存 并刷新列表页面
      var toHtData = {};
      toHtData.tableId = that.pageSetInfo.tableId;
      toHtData.pxValue = that.value[that.fieldInfo.fieldAliasName]
      that.isLoading = true;
      //根据pageId获取列表页面的设置信息 获取列表页面的数据信息
      utils.request(that,{
          url: 'wxXcxSet_interfaceToList.do', //仅为示例，并非真实的接口地址
          data: toHtData,
          success: function (res) {
              that.isLoading = false;
              if (res.data != null) {
                  
              } else {
              // 页面不存在
                  that.$notify.error({
                      title: '错误',
                      message: '页面不存在',
                      duration: 2000
                  });
              }
          }
      })
      this.editState = false;
    },
    cancelValue(){
      this.editState = false;
      this.value[this.fieldInfo.fieldAliasName] = this.editPrevValue;
    }
  }
}
        
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
